/* <wg-faq> — filters FAQ groups by category chip. */
if (!customElements.get('wg-faq')) {
  customElements.define(
    'wg-faq',
    class WgFaq extends HTMLElement {
      connectedCallback() {
        this.chips = [...this.querySelectorAll('[data-wg-filter]')];
        this.groups = [...this.querySelectorAll('[data-wg-category]')];
        this.chips.forEach((chip) => chip.addEventListener('click', () => this.filter(chip)));
      }

      filter(active) {
        const value = active.dataset.wgFilter;
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip === active)));
        this.groups.forEach((group) => {
          group.hidden = value !== 'all' && group.dataset.wgCategory !== value;
        });
      }
    }
  );
}
